import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';

const StickyNav = () => {
  const [visible, setVisible] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "THE BOOKS", href: "#books" },
    { label: "THE SERIES", href: "#series" },
    { label: "THE UNIVERSE", href: "#timeline" },
    { label: "THE GAME", href: "#game" },
    { label: "HOW TO PLAY", href: "/how-to-play", isPage: true },
    { label: "THE PLAYERS", href: "#players" },
  ];

  const scrollTo = (href, isPage) => {
    setMobileOpen(false);
    if (isPage) {
      window.location.href = href;
      return;
    }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.nav
          initial={{ y: -80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -80, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed top-0 left-0 right-0 z-50 bg-[#050505]/90 backdrop-blur-md border-b border-[#C9A84C]/10"
          data-testid="sticky-nav"
        >
          <div className="max-w-7xl mx-auto px-6 h-14 flex items-center justify-between">
            {/* Logo */}
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="hover:opacity-80 transition-opacity"
              data-testid="nav-logo"
            >
              <img src="/kow-site-logo.png" alt="KOW" className="h-10 w-auto" />
            </button>

            {/* Desktop Links */}
            <div className="hidden md:flex items-center gap-8">
              {links.map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollTo(link.href, link.isPage)}
                  className="font-['Outfit'] text-[#E8E0D0]/60 text-xs tracking-widest hover:text-[#C9A84C] transition-colors"
                  data-testid={`nav-link-${link.href.replace(/^[#/]/, '')}`}
                >
                  {link.label}
                </button>
              ))}
            </div>

            {/* Ask The Water (desktop) */}
            <button
              onClick={() => {
                const btn = document.querySelector('[data-testid="ask-water-toggle"]');
                if (btn) btn.click();
              }}
              className="hidden md:block font-['Outfit'] text-xs tracking-widest text-[#C9A84C] border border-[#C9A84C]/40 px-4 py-1.5 rounded hover:bg-[#C9A84C]/10 transition-colors"
              data-testid="nav-ask-water"
            >
              ASK THE WATER
            </button>

            {/* Mobile hamburger */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden text-[#C9A84C]"
              data-testid="nav-mobile-toggle"
            >
              {mobileOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>

          {/* Mobile dropdown */}
          <AnimatePresence>
            {mobileOpen && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                className="md:hidden overflow-hidden bg-[#050505]/95 border-t border-[#C9A84C]/10"
              >
                <div className="px-6 py-4 space-y-3">
                  {links.map((link) => (
                    <button
                      key={link.href}
                      onClick={() => scrollTo(link.href, link.isPage)}
                      className="block w-full text-left font-['Outfit'] text-[#E8E0D0]/70 text-sm tracking-widest hover:text-[#C9A84C] transition-colors py-1"
                    >
                      {link.label}
                    </button>
                  ))}
                  <button
                    onClick={() => {
                      setMobileOpen(false);
                      const btn = document.querySelector('[data-testid="ask-water-toggle"]');
                      if (btn) btn.click();
                    }}
                    className="block w-full text-left font-['Outfit'] text-[#C9A84C] text-sm tracking-widest py-1"
                  >
                    ASK THE WATER
                  </button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.nav>
      )}
    </AnimatePresence>
  );
};

export default StickyNav;
